webpackJsonp([1],{

/***/ "0+ER":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HelloWorld.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var HelloWorld = ({
  name: 'HelloWorld',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      flickityOptions: {
        initialIndex: 3,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true
      }
    };
  },

  components: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72ab7405","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloWorld.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sorry"},[_c('div',{staticClass:"what-we-do section",attrs:{"id":"what-we-do"}},[_c('div',{staticStyle:{"margin":"auto"}},[_c('span',{staticStyle:{"font-size":"10vh"}},[_vm._v(":(")]),_c('br'),_c('br'),_vm._v("\n      We are currently down for maintenance. "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"small"},[_vm._v("\n        We expect to have all our services running in a couple of hours. Thank you for your patience.\n    ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_HelloWorld = (esExports);
// CONCATENATED MODULE: ./src/components/HelloWorld.vue
function injectStyle (ssrContext) {
  __webpack_require__("Nsfi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72ab7405"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  HelloWorld,
  components_HelloWorld,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_HelloWorld = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TitleHeader.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TitleHeader = ({
  name: 'TitleHeader',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335ac0e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TitleHeader.vue
var TitleHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var TitleHeader_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('a',{attrs:{"href":"/"}},[_vm._v("P H O T O  A I")]),_vm._v(" "),_c('a',{staticClass:"item",attrs:{"href":"#what-we-do"}},[_vm._v("\n    About Us\n  ")]),_vm._v(" "),_c('a',{staticClass:"item",attrs:{"href":"#company"}},[_vm._v("\n    Branding\n  ")]),_vm._v(" "),_c('a',{staticClass:"item",attrs:{"href":"#influencer"}},[_vm._v("\n    Influencers\n  ")]),_vm._v(" "),_c('a',{staticClass:"item",attrs:{"href":"#hello"}},[_vm._v("\n    Marketing\n  ")])])}]
var TitleHeader_esExports = { render: TitleHeader_render, staticRenderFns: TitleHeader_staticRenderFns }
/* harmony default export */ var components_TitleHeader = (TitleHeader_esExports);
// CONCATENATED MODULE: ./src/components/TitleHeader.vue
function TitleHeader_injectStyle (ssrContext) {
  __webpack_require__("ULL9")
}
var TitleHeader_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var TitleHeader___vue_template_functional__ = false
/* styles */
var TitleHeader___vue_styles__ = TitleHeader_injectStyle
/* scopeId */
var TitleHeader___vue_scopeId__ = "data-v-335ac0e6"
/* moduleIdentifier (server only) */
var TitleHeader___vue_module_identifier__ = null
var TitleHeader_Component = TitleHeader_normalizeComponent(
  TitleHeader,
  components_TitleHeader,
  TitleHeader___vue_template_functional__,
  TitleHeader___vue_styles__,
  TitleHeader___vue_scopeId__,
  TitleHeader___vue_module_identifier__
)

/* harmony default export */ var src_components_TitleHeader = (TitleHeader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FooterComp.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var FooterComp = ({
  name: 'FooterComp',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e9bc6db","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterComp.vue
var FooterComp_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var FooterComp_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"item"},[_c('i',[_vm._v("Sales")]),_c('br'),_vm._v("\n    emma@photoai.tech\n  ")]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('i',[_vm._v("Customer Support")]),_c('br'),_vm._v("\n    support@photoai.tech\n  ")]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('i',[_vm._v("Other")]),_c('br'),_vm._v("\n    derek@photoai.tech\n  ")])])}]
var FooterComp_esExports = { render: FooterComp_render, staticRenderFns: FooterComp_staticRenderFns }
/* harmony default export */ var components_FooterComp = (FooterComp_esExports);
// CONCATENATED MODULE: ./src/components/FooterComp.vue
function FooterComp_injectStyle (ssrContext) {
  __webpack_require__("0+ER")
}
var FooterComp_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var FooterComp___vue_template_functional__ = false
/* styles */
var FooterComp___vue_styles__ = FooterComp_injectStyle
/* scopeId */
var FooterComp___vue_scopeId__ = "data-v-2e9bc6db"
/* moduleIdentifier (server only) */
var FooterComp___vue_module_identifier__ = null
var FooterComp_Component = FooterComp_normalizeComponent(
  FooterComp,
  components_FooterComp,
  FooterComp___vue_template_functional__,
  FooterComp___vue_styles__,
  FooterComp___vue_scopeId__,
  FooterComp___vue_module_identifier__
)

/* harmony default export */ var src_components_FooterComp = (FooterComp_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TempAna.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TempAna = ({
  name: 'TempAna',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      flickityOptions: {
        initialIndex: 3,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true
      }
    };
  },

  methods: {
    analyze: function analyze(what) {
      if (window.gtag) {
        window.gtag('event', 'clicked', {
          'event_label': what
        });
      }
      this.$emit('clicked');
    }
  },
  components: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b1182b1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TempAna.vue
var TempAna_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"hello section",attrs:{"id":"hello"}},[_c('div',{staticClass:"left col"},[_c('div',{staticClass:"content"},[_vm._v("\n        Get insights from your social marketing campaigns.\n        Try "),_c('i',[_vm._v("1000 images for free")]),_vm._v("."),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"button",on:{"click":function($event){_vm.analyze('marketing')}}},[_vm._v("Analyze your images")])])]),_vm._v(" "),_c('div',{staticClass:"right col"})]),_vm._v(" "),_c('div',{staticClass:"influencer section",attrs:{"id":"influencer"}},[_c('div',{staticClass:"left col"}),_vm._v(" "),_c('div',{staticClass:"right col"},[_c('div',{staticClass:"content"},[_vm._v("\n        Screen influencers with our brand safety check.\n        Analyze "),_c('i',[_vm._v("100 influencers for free")]),_vm._v("."),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"button",on:{"click":function($event){_vm.analyze('influencers')}}},[_vm._v("Screen influencers")])])])]),_vm._v(" "),_c('div',{staticClass:"company section",attrs:{"id":"company"}},[_c('div',{staticClass:"left col"},[_c('div',{staticClass:"content"},[_vm._v("\n        Analyze your companies image bank and gain insights into how well they convey your brand.\n        Try "),_c('i',[_vm._v("1000 images for free")]),_vm._v("."),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"button",on:{"click":function($event){_vm.analyze('branding')}}},[_vm._v("Analyze your images")])])]),_vm._v(" "),_c('div',{staticClass:"right col"})]),_vm._v(" "),_vm._m(0)])}
var TempAna_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"what-we-do section",attrs:{"id":"what-we-do"}},[_c('div',[_vm._v("\n      At Photo AI we work with the best artificial intelligence technologies in the world. We use insights from these technologies to create "),_c('i',[_vm._v("real value")]),_vm._v(" for companies. Our core is to give valuable insights from large sets of images."),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"small"},[_vm._v("\n        - Derek Hols, Founder & CEO\n    ")])])])}]
var TempAna_esExports = { render: TempAna_render, staticRenderFns: TempAna_staticRenderFns }
/* harmony default export */ var components_TempAna = (TempAna_esExports);
// CONCATENATED MODULE: ./src/components/TempAna.vue
function TempAna_injectStyle (ssrContext) {
  __webpack_require__("f9Wp")
}
var TempAna_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var TempAna___vue_template_functional__ = false
/* styles */
var TempAna___vue_styles__ = TempAna_injectStyle
/* scopeId */
var TempAna___vue_scopeId__ = "data-v-7b1182b1"
/* moduleIdentifier (server only) */
var TempAna___vue_module_identifier__ = null
var TempAna_Component = TempAna_normalizeComponent(
  TempAna,
  components_TempAna,
  TempAna___vue_template_functional__,
  TempAna___vue_styles__,
  TempAna___vue_scopeId__,
  TempAna___vue_module_identifier__
)

/* harmony default export */ var src_components_TempAna = (TempAna_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//






/* harmony default export */ var App = ({
  name: 'app',
  data: function data() {
    return {
      ana: false
    };
  },

  methods: {
    run: function run() {
      this.ana = true;
    }
  },
  components: {
    HelloWorld: src_components_HelloWorld,
    TitleHeader: src_components_TitleHeader,
    FooterComp: src_components_FooterComp,
    TempAna: src_components_TempAna
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e2d3da6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('TitleHeader'),_vm._v(" "),(_vm.ana === false)?_c('TempAna',{on:{"clicked":function($event){_vm.run()}}}):_c('HelloWorld'),_vm._v(" "),_c('FooterComp')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("mieU")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "Nsfi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ULL9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f9Wp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mieU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.692f9c96411b0b60dda6.js